import {DamageCostsRank} from '@/vuex/modules/barCharts/DamageCostsRank.js'
import {DistractedDrivingRank} from '@/vuex/modules/barCharts/DistractedDrivingRank.js'
import {FatalitiesRank} from '@/vuex/modules/barCharts/FatalitiesRank.js'
import {InjuriesRank} from '@/vuex/modules/barCharts/InjuriesRank.js'
import {ParkedCarsHitRank} from '@/vuex/modules/barCharts/ParkedCarsHitRank.js'
import {PeopleBikingRank} from '@/vuex/modules/barCharts/PeopleBikingRank.js'
import {PeopleInvolvedRank} from '@/vuex/modules/barCharts/PeopleInvolvedRank.js'
import {PeopleWalkingRank} from '@/vuex/modules/barCharts/PeopleWalkingRank.js'
import {PossibleInjuriesRank} from '@/vuex/modules/barCharts/PossibleInjuriesRank.js'
import {PropertyDamageOnlyRank} from '@/vuex/modules/barCharts/PropertyDamageOnlyRank.js'
import {SeriousInjuriesRank} from '@/vuex/modules/barCharts/SeriousInjuriesRank.js'
import {SpeedingRank} from '@/vuex/modules/barCharts/SpeedingRank.js'
import {TotalCollisionsRank} from '@/vuex/modules/barCharts/TotalCollisionsRank.js'
import {UnderTheInfluenceRank} from '@/vuex/modules/barCharts/UnderTheInfluenceRank.js'

import {FullListRank} from '@/vuex/modules/trays/FullListRank.js'

const modules = {
  fullList: FullListRank,

  costs: DamageCostsRank,
  distractedDriving: DistractedDrivingRank,
  fatalities: FatalitiesRank,
  injuries: InjuriesRank,
  parkedCarsHit: ParkedCarsHitRank,
  peopleBiking: PeopleBikingRank,
  peopleInvolved: PeopleInvolvedRank,
  peopleWalking: PeopleWalkingRank,
  possibleInjuries: PossibleInjuriesRank,
  propertyDamageOnly: PropertyDamageOnlyRank,
  seriousInjuries: SeriousInjuriesRank,
  speeding: SpeedingRank,
  totalCollisions: TotalCollisionsRank,
  underTheInfluence: UnderTheInfluenceRank
}

const state = {
  resultsFilters: {}
}

const mutations = {
  SET_RESULTS_FILTERS (state, filters) {
    state.resultsFilters = filters
  }
}

const actions = {
  fetchAll: function ({commit, dispatch}, filters) {
    commit('SET_RESULTS_FILTERS', filters)

    dispatch('costs/fetch', {slug: '/districts/city/ranks/costs/economic/desc', filters: filters})
    dispatch('distractedDriving/fetch', {slug: '/districts/city/ranks/who/inattentionind/desc', filters: filters})
    dispatch('fatalities/fetch', {slug: '/districts/city/ranks/severity/5/desc', filters: filters})
    dispatch('injuries/fetch', {slug: '/districts/city/ranks/severity/1/desc', filters: filters})
    dispatch('parkedCarsHit/fetch', {slug: '/districts/city/ranks/who/hitparkedcar/desc', filters: filters})
    dispatch('peopleBiking/fetch', {slug: '/districts/city/ranks/who/pedcylcount/desc', filters: filters})
    dispatch('peopleInvolved/fetch', {slug: '/districts/city/ranks/who/personcount/desc', filters: filters})
    dispatch('peopleWalking/fetch', {slug: '/districts/city/ranks/who/pedcount/desc', filters: filters})
    dispatch('possibleInjuries/fetch', {slug: '/districts/city/ranks/severity/3/desc', filters: filters})
    dispatch('propertyDamageOnly/fetch', {slug: '/districts/city/ranks/severity/2/desc', filters: filters})
    dispatch('seriousInjuries/fetch', {slug: '/districts/city/ranks/severity/4/desc', filters: filters})
    dispatch('speeding/fetch', {slug: '/districts/city/ranks/who/speeding/desc', filters: filters})
    dispatch('totalCollisions/fetch', {slug: '/districts/city/ranks/totalcollisions/desc', filters: filters})
    dispatch('underTheInfluence/fetch', {slug: '/districts/city/ranks/who/underinfl/desc', filters: filters})
  },

  setFilters: function ({commit, dispatch, rootState}) {
    let startDate = (typeof rootState.route.params.sd === 'undefined') ? '2006-01-01' : rootState.route.params.sd

    dispatch('filterDateRange/setStartDate', startDate, {root: true})
    dispatch('filterDateRange/setEndDate', rootState.route.params.ed, {root: true})
  },

  resetResults: function ({dispatch}) {
    dispatch('totalCollisions/reset')
    dispatch('costs/reset')
    dispatch('fatalities/reset')
    dispatch('seriousInjuries/reset')
    dispatch('injuries/reset')
    dispatch('propertyDamageOnly/reset')
    dispatch('possibleInjuries/reset')
    dispatch('peopleInvolved/reset')
    dispatch('peopleWalking/reset')
    dispatch('peopleBiking/reset')
    dispatch('parkedCarsHit/reset')
    dispatch('speeding/reset')
    dispatch('distractedDriving/reset')
    dispatch('underTheInfluence/reset')
  }
}

const getters = {
  filters (state, getters, rootState) {
    return {
      startDate: rootState.filterDateRange.startDate,
      endDate: rootState.filterDateRange.endDate
    }
  },

  resultsFilters: state => state.resultsFilters
}

export const CityCouncilDistrictRanksView = {
  namespaced: true,
  modules,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/views/CityCouncilDistrictRanksView.js